export class ProblemDetailTypes {
  public static readonly CasAppUnelectedVendorErrorType = 'CASapp.UnelectedVendorErrorType';
  public static readonly FatZebraProcessingError = 'FatZebraProcessingError';
  public static readonly PaywayAccountValidationError = 'PaywayAccountValidationError';
}
